import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { CartItem } from 'graphql/types/CartItem';

export const useQueryReplacementAvailableChoice = (
  options?: QueryHookOptions<
    ReplacementAvailableChoiceData,
    ReplacementAvailableChoiceVariables
  >,
) =>
  useQuery<ReplacementAvailableChoiceData, ReplacementAvailableChoiceVariables>(
    REPLACEMENT_AVAILABLE_CHOICE,
    options,
  );

export const REPLACEMENT_AVAILABLE_CHOICE = gql`
  query replacementAvailableChoice($section: String) {
    replacementAvailableChoice {
      id
      quantity
      monitored(section: $section)
      commodity {
        price
        currency
        sellable
        itemCode
        description
        stockStatus
        stocks {
          stock
          source
          id
          location
          status
        }
        replacements {
          setNumber
          quantity
          commodity {
            itemCode
            id
            price
            currency
            sellable
            description
          }
          items {
            id
            quantity
            commodity {
              itemCode
              id
              price
              currency
              sellable
              description
            }
            replacement {
              remarks
            }
          }
          id
          createdAt
          updatedAt
        }
        validate {
          setNumber
          quantity
          commodity
          items {
            id
            commodity {
              itemCode
              id
              price
              currency
              sellable
              description
            }
          }

          id
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export type ReplacementAvailableChoiceVariables = {
  section: string;
};

export type ReplacementAvailableChoiceData = {
  replacementAvailableChoice: CartItem[];
};
